import { Dialog } from '@mui/material';
import React, { useState } from 'react';

import GeneratePaymentRequestPassiveStep from './GeneratePaymentRequestPassive';
import GeneratePayoutStep from './GeneratePayouts';

const PayoutPendingAccounts = (props: any) => {
  const { open, setOpen, setSuccessOpen, setFailureOpen, setUp, config } =
    props;
  const [step, setStep] = useState(1);
  const [selectedRequest, setSelectedRequest] = useState<number | null>(null);

  const operationDateDefault = new Date();
  operationDateDefault.setUTCHours(12);

  function GeneratePaymentRequestNextStep() {
    setSuccessOpen('Devolución de pasivos creada con éxito');
    if (!config) return setStep(2);
    setUp();
    setOpen(false);
  }

  function GeneratePayoutNextStep() {
    setSuccessOpen('Pago configurado con éxito');
    setUp();
    setOpen(false);
  }

  function GeneratePayoutStepBack() {
    setUp();
    setOpen(false);
  }

  return (
    <Dialog open={open} maxWidth="xl" onClose={() => setOpen(false)}>
      {step === 1 && (
        <GeneratePaymentRequestPassiveStep
          nextStep={GeneratePaymentRequestNextStep}
          stepBack={() => setOpen(false)}
          setSelectedRequest={setSelectedRequest}
          setFailureOpen={setFailureOpen}
        />
      )}
      {step === 2 && (
        <GeneratePayoutStep
          nextStep={GeneratePayoutNextStep}
          stepBack={GeneratePayoutStepBack}
          selectedRequest={selectedRequest}
          setFailureOpen={setFailureOpen}
        />
      )}
    </Dialog>
  );
};

export default PayoutPendingAccounts;
